export default{
    getDiagnosticFilter: state => state.filter,
    getDiagnosticList: state => state.list,
    getDiagnosticValidation: state => state.validation
}